import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Banner, StackBlock } from '@yonderland/andes-react';
import { isEmptyString } from '@as-react/common-utils';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { getQuerystringByName } from '../../../util/URLParamUtil';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { makeGetBasketPricingState } from '../../../redux/basket/selectors/BasketSelector';
import { usePaymentState } from '../../../context/CheckoutPaymentContext';
export const PaymentNotification = () => {
    const { t } = useTranslation([I18N_NAMESPACES.buy, I18N_NAMESPACES.checkout]);
    const [payerMessage, setPayerMessage] = useState();
    const pricing = useSelector(makeGetBasketPricingState());
    const [{ info }] = usePaymentState();
    const showPendingPaymentMessage = Boolean(pricing.totalPendingPaymentAmount) && !info.fullyPaid;
    useEffect(() => {
        const messageQueryParam = getQuerystringByName(window.location.search, 'payerMessage');
        setPayerMessage(isEmptyString(messageQueryParam) ? t(`${I18N_NAMESPACES.buy}:buy.payment.form.error`) : messageQueryParam);
    }, []);
    return (_jsxs(StackBlock, { gap: "3", children: [Boolean(payerMessage) && _jsx(Banner, { status: "error", text: payerMessage, testId: "saferpay-message" }), showPendingPaymentMessage && (_jsx(Banner, { status: "informative", text: t(`${I18N_NAMESPACES.checkout}:checkout.basket.pending_payment.message`), testId: "pending-payment-message" }))] }));
};
